export default class AuthService {
  // 서버에서 받은 토큰 어디에 저장할건지
  // client brower local storage? cookie?
  // local storage는 보안에 매우 취약
  // http only option으로 cookie로 보내기
  constructor(http) {
    this.http = http;
  }

  async signup(username, password, name, email, url) {
    return this.http.fetch("/auth/signup", {
      method: "POST",
      body: JSON.stringify({
        username,
        password,
        name,
        email,
        url,
      }),
    });
  }
  async login(username, password) {
    return this.http.fetch("/auth/login", {
      method: "POST",
      body: JSON.stringify({ username, password }),
    });
  }

  async me() {
    return this.http.fetch("/auth/me", {
      method: "GET",
    });
  }

  // 서버에 요청 -> 응답에 빈토큰 받음
  async logout() {
    return this.http.fetch("/auth/logout", {
      method: "POST", // GET은 브라우저가 맘대로 미리 실행해버릴 수 있어 위험함
    });
  }

  async csrfToken() {
    const resp = await this.http.fetch("/auth/csrf-token", {
      method: "GET",
    });
    return resp.csrfToken;
  }
}
